import { useState, useCallback } from "react";

export const useImageCropper = () => {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [open, setOpen] = useState(false);

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const openCropper = (file) => {
  const reader = new FileReader();
  reader.onload = () => {
    setImageSrc(reader.result);
    // Setting crop to {x: 0, y: 0} usually centers the image 
    // relative to the crop area automatically.
    setCrop({ x: 0, y: 0 }); 
    setZoom(1);
    setOpen(true);
  };
  reader.readAsDataURL(file);
};

  const closeCropper = () => {
    setOpen(false);
    setImageSrc(null);
  };

  return {
    imageSrc, crop, zoom, croppedAreaPixels, open,
    setCrop, setZoom, onCropComplete, openCropper, closeCropper,
  };
};
